import { Flex, FlexProps } from '@chakra-ui/react';
import { AppointmentDetailsTabs } from './components/AppointmentDetailsTabs';

const AppointmentDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <AppointmentDetailsTabs />
  </Flex>
);

export default AppointmentDetailsData;
